export default __webpack_public_path__ + "images/ikonka_lokalizacja_win.png";